initHeader();

function initHeader() {
  document.querySelector('.shopify-section-header').addEventListener('click', function (event) {
    const clickEventPath = event.composedPath().slice(0, -2);

    for (const element of clickEventPath) {
      const clickAction = element.getAttribute('data-click-action');

      if (clickAction === 'open-menu-drawer') {
        openMenuDrawerHandler();
        break;
      } else if (clickAction === 'open-cart-drawer') {
        openCartDrawerHandler();
        window.mx.hideGorgiasButton();
        break;
      }
    }
  });
}

function openMenuDrawerHandler() {
  document.querySelector('.mx-menu-drawer').setAttribute('data-open', '');
  document.documentElement.style.scrollBehavior = 'auto';
  document.documentElement.style.top = `-${window.scrollY}px`;
  document.documentElement.setAttribute('data-locked', '');
}

function openCartDrawerHandler() {
  document.querySelector('.mx-cart-drawer').setAttribute('data-open', '');
  document.documentElement.style.scrollBehavior = 'auto';
  document.documentElement.style.top = `-${window.scrollY}px`;
  document.documentElement.setAttribute('data-locked', '');
}